import { Space } from 'antd';
import type { ReactNode } from 'react';

interface AdminListToolbarProps {
  filters?: ReactNode;
  actions?: ReactNode;
  /** Hook for a feature that needs its own toolbar layout (e.g. stacked rows). */
  className?: string;
}

export function AdminListToolbar({ filters, actions, className }: AdminListToolbarProps) {
  return (
    <div
      className={className}
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 12,
        marginBottom: 16,
        flexWrap: 'wrap',
      }}
    >
      {/* `table-filters` es la regla global que apila los filtros en móvil. */}
      <Space wrap size={[8, 8]} className="table-filters" style={{ flex: 1, minWidth: 0 }}>
        {filters}
      </Space>
      {actions && (
        <Space wrap size={[8, 8]}>
          {actions}
        </Space>
      )}
    </div>
  );
}
